import React from 'react';

const DebugComponent: React.FC = () => {

    return (
        <div>
            <h2>Debug Information</h2>
            <p>User Agent: {navigator.userAgent}</p>
            <p>Is Mobile: {/(iPhone|iPad|iPod|Android)/i.test(navigator.userAgent) ? 'Yes' : 'No'}</p>
        </div>
    );
};

export default DebugComponent;